<template>
  <div class="offer-card">
    <div class="offer-card__main">
      <div class="offer-card__company-wrapper">
        <CompanyInfo
          :company-logo="offer.company.logo"
          :company-name="offer.company.name"
          :company-rating="offer.company.rating"
          :has-company-branches="offer.company.hasBranch"
          @show-company-locations="showCompanyBranches"
        />
      </div>
      <OfferCardParams
        :open-details="isOpenDetails"
        :insurance-period="offer.contract.insurancePeriod"
        @toggle-details="toggleOfferDetails"
      />
      <OfferCardPrice
        :show-earnings="showEarnings"
        :net-payment="getNetPrice"
        :price="getBasePrice"
        :total-price="getBasePrice"
        :threshold-price="getNetPrice"
        :discount="0"
        :earnings-value="getAgentCommissionAmount"
        :earnings-percent="getAgentCommissionPercent"
        :is-loading="isLoading"
        @select-offer="onSelectOffer"
      />
    </div>

    <transition name="expand">
      <div
        v-show="isOpenDetails"
        class="offer-card__expanded"
      >
        <Tab
          ref="detailsTabs"
          :tabs="getDetailsTabs"
        >
          <template #common-info>
            <OfferDetails
              :document-links="offer.company.documents"
              :description="offer.company.description"
            />
          </template>
        </Tab>
      </div>
    </transition>

    <CompanyBranchesPopup
      ref="companyBranchesPopup"
      :company-id="offer.company.id"
    />
  </div>
</template>

<script>
import { default as CompanyInfo } from './company-info';
import { default as OfferCardParams } from './offer-card-params';
import { default as OfferCardPrice } from './offer-card-price';
import { default as OfferDetails } from './offer-details';
import { NumberFormatter } from '@/shared/lib/number';
import { CompanyBranchesPopup } from '@/shared/ui/insurance';
import { Tab } from '@/shared/ui/tab';

const { formatNumber } = NumberFormatter();

export default {
  props: {
    showEarnings: {
      type: Boolean,
      default: false,
    },
    offer: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDetails: false,
    };
  },
  components: { CompanyInfo, OfferCardParams, OfferCardPrice, OfferDetails, Tab, CompanyBranchesPopup },
  computed: {
    getBasePrice() {
      return Number(this.offer.pricing.basePrice);
    },
    getNetPrice() {
      return Number(this.offer.pricing.netPrice);
    },
    getAgentCommissionAmount() {
      return Number(this.offer.pricing.agentCommission.own);
    },
    getAgentCommissionPercent() {
      return Number(this.offer.pricing.agentCommission.ownPercent);
    },
    isOpenDetails() {
      return this.openDetails;
    },
    getDetailsTabs() {
      return [
        {
          id: 'common-info',
          title: 'Загальна інформація',
        },
      ];
    },
  },
  methods: {
    formatNumber,
    toggleOfferDetails(open) {
      this.openDetails = open;

      if (open) {
        this.$refs.detailsTabs.setActiveTab('common-info');
      }
    },
    showCompanyBranches() {
      this.$refs.companyBranchesPopup.open();
    },
    onSelectOffer() {
      this.$emit('select-offer', this.offer);
    },
  },
};
</script>

<style scoped lang="scss">
.offer-card {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 3px 0 rgba(0, 0, 0, 0.1);

  &__main {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    @media (max-width: 800px) {
      flex-wrap: wrap;
      align-items: center;
      gap: 0;

      .offer-card__company-wrapper {
        flex: 1 0 auto;
        order: 1;
      }

      ::v-deep .proposition-params {
        flex: 0 0 100%;
        order: 3;
      }

      ::v-deep .proposition-price {
        flex: 0 0 auto;
        order: 2;
      }
    }

    @media (max-width: 500px) {
      flex-direction: column;
      align-items: center;

      .offer-card__company-wrapper {
        flex: 0 0 auto;
        order: 1;
      }

      ::v-deep .proposition-params {
        flex: 0 0 auto;
        order: 2;
      }

      ::v-deep .proposition-price {
        flex: 0 0 auto;
        order: 3;
      }
    }
  }

  &__company-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 14px;

    @media (max-width: 800px) {
      margin-bottom: 0;
    }
  }

  &__expanded {
    border-top: 1px solid #cbd5e1;
    padding: 32px 24px;

    @media (max-width: 800px) {
      padding: 24px 16px;
    }
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, padding 0.3s ease-in-out;
  max-height: 1000px;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
